import { Visibility, VisibilityOff } from "@mui/icons-material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment
} from "@mui/material";
import { Form } from "formik";
import * as yup from "yup";
import FormikCaptcha from "../../commons/formik/formikCaptcha";
import FormikForm from "../../commons/formik/formikForm";
import FormikTextField from "../../commons/formik/formikTextField";
import { StyledLoginContainer } from "../../styled/login";
import packagejson from "../../../../package.json";

const validationSchema = yup.object({
  userName: yup
    .string()
    .email("Dirección de correo inválida")
    .required("Campo obligatorio"),
  password: yup.string().required("Campo obligatorio"),
});

const initialValues = {
  // notese la N mayúscula en userName, ya que el back
  // espera el campo "userName", no "username" todo en minúscula.
  userName: "",
  password: "",
  version: packagejson.version,
};

const LoginForm = ({
  handleSubmit,
  loading,
  captchaRef,
  showPassword,
  togglePasswordVisibility,
}) => {
  return (
    <FormikForm
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}>
      {({ values }) => (
        <>
          <Form>

            <Grid container direction={"row"} spacing={2} nowrap="true">
              <StyledLoginContainer.GridRowItem item xs={12}>
                <AccountCircleIcon sx={{ marginRight: 1 }} />
                <FormikTextField
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  label="Usuario"
                  name="userName"
                  autoFocus
                  type="text"
                />
              </StyledLoginContainer.GridRowItem>
            </Grid>
            <Grid
              container
              direction={"row"}
              spacing={2}
              alignItems="center">
              <StyledLoginContainer.GridRowItem item xs={12}>
                <LockOutlinedIcon sx={{ marginRight: 1 }} />
                <FormikTextField
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  name="password"
                  label="Contraseña"
                  type={showPassword ? "text" : "password"}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={togglePasswordVisibility}
                          edge="end">
                          {showPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </StyledLoginContainer.GridRowItem>
            </Grid>
            <Grid container direction="row" mt={1} alignItems="center">
              <Grid container justifyContent="center" item xs={12}>
                <FormikCaptcha ref={captchaRef} />
              </Grid>
            </Grid>
            <StyledLoginContainer.SubmitButton
              color="primary"
              variant="contained"
              fullWidth
              type="submit"
              disabled={loading || (CONFIG.useCaptcha && !values.token)}>
              {loading ? (
                <CircularProgress
                  size={24}
                  thickness={4}
                  color="secondary"
                />
              ) : (
                "Ingresar"
              )}
            </StyledLoginContainer.SubmitButton>

          </Form>
        </>
      )}
    </FormikForm>
  );
};

export default LoginForm;
